import { render, staticRenderFns } from "./PortalAnnouncementsPanel.vue?vue&type=template&id=696e75bc&scoped=true&"
import script from "./PortalAnnouncementsPanel.vue?vue&type=script&lang=ts&"
export * from "./PortalAnnouncementsPanel.vue?vue&type=script&lang=ts&"
import style0 from "./PortalAnnouncementsPanel.vue?vue&type=style&index=0&id=696e75bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696e75bc",
  null
  
)

export default component.exports